import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ref", "__animatedEnhanceInstanceId", "duration"];
import React from 'react';
import { useForkRef } from "../ref.mjs";
import useEnhancedEffect from "../use/useEnhancedEffect.mjs";
var uniqueId = 0;
function animatedSizeEnhance(_ref) {
  var _ref$animateProps = _ref.animateProps,
    animateProps = _ref$animateProps === void 0 ? [] : _ref$animateProps,
    _ref$onChangeOf = _ref.onChangeOf,
    onChangeOf = _ref$onChangeOf === void 0 ? [] : _ref$onChangeOf;
  return function (props) {
    var ref = props.ref,
      __animatedEnhanceInstanceId = props.__animatedEnhanceInstanceId,
      duration = props.duration,
      other = _objectWithoutProperties(props, _excluded);
    var nodeRef = /*#__PURE__*/React.createRef();
    var lastSizesRef = React.useRef([]);
    var prevPropsRef = React.useRef(props);
    var animatedSizeInstanceIdRef = React.useRef(uniqueId++);
    prevPropsRef.current = props;
    useEnhancedEffect(function () {
      if (props.animationsDisabled) return;
      if (__animatedEnhanceInstanceId !== undefined && __animatedEnhanceInstanceId !== animatedSizeInstanceIdRef.current) return;
      if (!nodeRef.current) {
        return;
      }
      var node = nodeRef.current;
      if (lastSizesRef.current.every(function (value) {
        return value === undefined;
      })) {
        for (var i = 0; i < animateProps.length; i++) {
          lastSizesRef.current[i] = node.getBoundingClientRect()[animateProps[i]];
        }
        return;
      }
      var sizes = [];
      for (var _i = 0; _i < animateProps.length; _i++) {
        sizes[_i] = node.getBoundingClientRect()[animateProps[_i]];
        if (Math.abs(lastSizesRef.current[_i] - sizes[_i]) < 3 || node.style.getPropertyValue(animateProps[_i]).endsWith('%')) {
          lastSizesRef.current[_i] = sizes[_i];
          sizes[_i] = undefined;
        }
      }
      if (sizes.every(function (value) {
        return value === undefined;
      })) return;
      node.style.transition = 'none';
      for (var _i2 = 0; _i2 < animateProps.length; _i2++) {
        node.style[animateProps[_i2]] = "".concat(lastSizesRef.current[_i2], "px");
      }
      var timeout = -1;
      var handleTransitionEnd = function handleTransitionEnd() {
        clearTimeout(timeout);
        if (!node) return;
        node.style.transition = null;
        for (var _i3 = 0; _i3 < animateProps.length; _i3++) {
          node.style[animateProps[_i3]] = null;
        }
        node.removeEventListener('transitionend', handleTransitionEnd);
        node.removeEventListener('transitioncancel', handleTransitionEnd);
      };
      var animationFrame = requestAnimationFrame(function () {
        if (!node) return;
        node.addEventListener('transitionend', handleTransitionEnd);
        node.addEventListener('transitioncancel', handleTransitionEnd);
        node.style.transition = "".concat(duration, "ms all ease-in-out");
        for (var _i4 = 0; _i4 < animateProps.length; _i4++) {
          lastSizesRef.current[_i4] = sizes[_i4];
          node.style[animateProps[_i4]] = "".concat(sizes[_i4], "px");
        }
      });
      timeout = setTimeout(handleTransitionEnd, 500);
      return function () {
        cancelAnimationFrame(animationFrame);
        handleTransitionEnd();
      };
    }, [__animatedEnhanceInstanceId, props.animationsDisabled, duration].concat(_toConsumableArray(onChangeOf.map(function (propName) {
      return props[propName];
    }))));
    return _objectSpread({
      ref: useForkRef(ref, nodeRef),
      __animatedEnhanceInstanceId: __animatedEnhanceInstanceId !== null && __animatedEnhanceInstanceId !== void 0 ? __animatedEnhanceInstanceId : animatedSizeInstanceIdRef.current
    }, other);
  };
}
export default animatedSizeEnhance;
//# sourceMappingURL=animatedSizeEnhance.mjs.map